import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { ApiCreateIpPoolResponse, CreateIpPoolRequest } from './types';

type Props = { artistId: string; data: CreateIpPoolRequest };

export const createIpPool = async ({ artistId, data }: Props) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/ip-pools`;

  const response = await api.executePostRequest<ObjectResponse<ApiCreateIpPoolResponse>>(url, data);

  return response.data;
};
